var map = {
	"./account.ts": 187,
	"./browseLog.ts": 188,
	"./common.ts": 189,
	"./customer.ts": 190,
	"./dictionary.ts": 191,
	"./dinerType.ts": 192,
	"./file.ts": 193,
	"./index.ts": 81,
	"./label.ts": 194,
	"./log.ts": 195,
	"./login.ts": 196,
	"./menu.ts": 197,
	"./platform.ts": 198,
	"./rankingTeam.ts": 199,
	"./role.ts": 200,
	"./sms.ts": 201,
	"./statistics.ts": 202,
	"./store.ts": 203,
	"./storeDinerType.ts": 204,
	"./tenant.ts": 205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 186;